// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 실행계획 보관함 — 창 모양·제목줄·버튼은 styles/appModal.css 공통이고, 여기는 본문 배치만. */

/* className 을 주면 공통의 기본 틀(app-modal-default)이 걸리지 않는다 — 창 틀은 여기서 준다.
   배경을 빠뜨리면 창이 투명해져 뒤 화면이 그대로 비친다(실측 2026-09-20). */
.parch-modal {
  width: min(960px, calc(calc(100vw / var(--app-zoom, 1)) - 48px));
  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 80px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  color: #222;
  border-radius: 10px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  animation: app-modal-rise 180ms ease-out;
}
[data-theme="dark"] .parch-modal {
  background: #1e1e1e;
  color: #ddd;
}
@media (prefers-reduced-motion: reduce) {
  .parch-modal { animation: none; }
}

.parch-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 12px;
  min-height: 0;
  flex: 1 1;
}

.parch-search {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 5px 9px;
  border: 1px solid var(--color-border, #d0d5dd);
  border-radius: 4px;
  background: var(--color-input-bg, #fff);
  color: var(--color-text-secondary, #6b7280);
  flex-shrink: 0;
}
.parch-search input {
  flex: 1 1;
  min-width: 0;
  border: none;
  outline: none;
  background: transparent;
  color: var(--color-text, #1f2937);
  font-size: 12px;
  font-family: var(--font-ui, 'Segoe UI', sans-serif);
}

/* 목록(좌) + 미리보기(우) */
.parch-split {
  display: flex;
  gap: 10px;
  flex: 1 1;
  min-height: 320px;
}

.parch-list {
  flex: 0 0 38%;
  min-width: 0;
  overflow-y: auto;
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 4px;
  background: var(--color-bg, #fff);
}

.parch-item {
  display: block;
  width: 100%;
  text-align: left;
  padding: 8px 10px;
  border: none;
  border-bottom: 1px solid var(--color-border, #eee);
  background: transparent;
  color: inherit;
  cursor: pointer;
  transition: background 150ms ease;
}
.parch-item:hover { background: var(--color-hover, rgba(0, 0, 0, 0.04)); }
.parch-item.active { background: var(--color-selected-bg, rgba(59, 130, 246, 0.12)); }

.parch-item-title {
  font-size: 12px;
  font-weight: 600;
  color: var(--color-text, #1f2937);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.parch-item-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  margin-top: 3px;
  font-size: 10px;
  color: var(--color-text-muted, #9ca3af);
}
.parch-chip {
  padding: 1px 6px;
  border-radius: 9px;
  background: var(--color-bg-tertiary, #f0f0f0);
  color: var(--color-text-secondary, #6b7280);
}
.parch-chip-pair {
  background: var(--color-accent, #3b82f6);
  color: #fff;
}

.parch-detail {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  border: 1px solid var(--color-border, #e0e0e0);
  border-radius: 4px;
  background: var(--color-bg, #fff);
  overflow: hidden;
}
.parch-detail-head {
  padding: 8px 10px;
  border-bottom: 1px solid var(--color-border, #eee);
  flex-shrink: 0;
}
.parch-detail-title {
  font-size: 13px;
  font-weight: 600;
  color: var(--color-text, #1f2937);
}
.parch-summary,
.parch-note {
  margin-top: 4px;
  font-size: 11px;
  color: var(--color-text-secondary, #6b7280);
  line-height: 1.5;
}

.parch-preview {
  flex: 1 1;
  min-height: 0;
  overflow: auto;
  margin: 0;
  padding: 8px 10px;
  font-family: 'Consolas', 'Monaco', monospace;
  font-size: 11px;
  line-height: 1.45;
  white-space: pre;
  color: var(--color-text, #333);
  background: var(--color-bg-secondary, #fafafa);
}

.parch-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 100%;
  min-height: 120px;
  padding: 16px;
  font-size: 12px;
  font-style: italic;
  color: var(--color-text-muted, #9ca3af);
  text-align: center;
}

.parch-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  flex-shrink: 0;
}
/* 되돌릴 수 없는 것은 오른쪽 끝에 따로 세운다 — 옆 버튼과 손이 섞이지 않게 */
.parch-delete { margin-left: auto; }

[data-theme="dark"] .parch-list,
[data-theme="dark"] .parch-detail { background: var(--color-bg-secondary); border-color: var(--color-border); }
[data-theme="dark"] .parch-preview { background: var(--color-bg); color: var(--color-text); }
[data-theme="dark"] .parch-item { border-bottom-color: var(--color-border); }

@media (prefers-reduced-motion: reduce) {
  .parch-item { transition: none; }
}
`, "",{"version":3,"sources":["webpack://./src/components/PlanArchiveModal.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAElE;mDACmD;AACnD;EACE,gEAAgE;EAChE,yDAAyD;EACzD,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,yCAAyC;EACzC,wCAAwC;AAC1C;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe,eAAe,EAAE;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,aAAa;EACb,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,uCAAuC;EACvC,2CAA2C;EAC3C,cAAc;AAChB;AACA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,mDAAmD;AACrD;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,SAAS;EACT,SAAO;EACP,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,kDAAkD;EAClD,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,iCAAiC;AACnC;AACA,oBAAoB,mDAAmD,EAAE;AACzE,qBAAqB,8DAA8D,EAAE;;AAErF;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,eAAe;EACf,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,2CAA2C;AAC7C;AACA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8CAA8C;EAC9C,kBAAkB;EAClB,iCAAiC;EACjC,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kDAAkD;EAClD,cAAc;AAChB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;AACA;;EAEE,eAAe;EACf,eAAe;EACf,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,4CAA4C;EAC5C,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;AAChB;AACA,gDAAgD;AAChD,gBAAgB,iBAAiB,EAAE;;AAEnC;oCACoC,qCAAqC,EAAE,iCAAiC,EAAE;AAC9G,qCAAqC,2BAA2B,EAAE,wBAAwB,EAAE;AAC5F,kCAAkC,wCAAwC,EAAE;;AAE5E;EACE,cAAc,gBAAgB,EAAE;AAClC","sourcesContent":["/* 실행계획 보관함 — 창 모양·제목줄·버튼은 styles/appModal.css 공통이고, 여기는 본문 배치만. */\r\n\r\n/* className 을 주면 공통의 기본 틀(app-modal-default)이 걸리지 않는다 — 창 틀은 여기서 준다.\r\n   배경을 빠뜨리면 창이 투명해져 뒤 화면이 그대로 비친다(실측 2026-09-20). */\r\n.parch-modal {\r\n  width: min(960px, calc(calc(100vw / var(--app-zoom, 1)) - 48px));\r\n  max-height: calc(calc(100vh / var(--app-zoom, 1)) - 80px);\r\n  display: flex;\r\n  flex-direction: column;\r\n  overflow: hidden;\r\n  background: #fff;\r\n  color: #222;\r\n  border-radius: 10px;\r\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\r\n  animation: app-modal-rise 180ms ease-out;\r\n}\r\n[data-theme=\"dark\"] .parch-modal {\r\n  background: #1e1e1e;\r\n  color: #ddd;\r\n}\r\n@media (prefers-reduced-motion: reduce) {\r\n  .parch-modal { animation: none; }\r\n}\r\n\r\n.parch-body {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n  padding: 12px;\r\n  min-height: 0;\r\n  flex: 1;\r\n}\r\n\r\n.parch-search {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 5px 9px;\r\n  border: 1px solid var(--color-border, #d0d5dd);\r\n  border-radius: 4px;\r\n  background: var(--color-input-bg, #fff);\r\n  color: var(--color-text-secondary, #6b7280);\r\n  flex-shrink: 0;\r\n}\r\n.parch-search input {\r\n  flex: 1;\r\n  min-width: 0;\r\n  border: none;\r\n  outline: none;\r\n  background: transparent;\r\n  color: var(--color-text, #1f2937);\r\n  font-size: 12px;\r\n  font-family: var(--font-ui, 'Segoe UI', sans-serif);\r\n}\r\n\r\n/* 목록(좌) + 미리보기(우) */\r\n.parch-split {\r\n  display: flex;\r\n  gap: 10px;\r\n  flex: 1;\r\n  min-height: 320px;\r\n}\r\n\r\n.parch-list {\r\n  flex: 0 0 38%;\r\n  min-width: 0;\r\n  overflow-y: auto;\r\n  border: 1px solid var(--color-border, #e0e0e0);\r\n  border-radius: 4px;\r\n  background: var(--color-bg, #fff);\r\n}\r\n\r\n.parch-item {\r\n  display: block;\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 8px 10px;\r\n  border: none;\r\n  border-bottom: 1px solid var(--color-border, #eee);\r\n  background: transparent;\r\n  color: inherit;\r\n  cursor: pointer;\r\n  transition: background 150ms ease;\r\n}\r\n.parch-item:hover { background: var(--color-hover, rgba(0, 0, 0, 0.04)); }\r\n.parch-item.active { background: var(--color-selected-bg, rgba(59, 130, 246, 0.12)); }\r\n\r\n.parch-item-title {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: var(--color-text, #1f2937);\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n.parch-item-meta {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  margin-top: 3px;\r\n  font-size: 10px;\r\n  color: var(--color-text-muted, #9ca3af);\r\n}\r\n.parch-chip {\r\n  padding: 1px 6px;\r\n  border-radius: 9px;\r\n  background: var(--color-bg-tertiary, #f0f0f0);\r\n  color: var(--color-text-secondary, #6b7280);\r\n}\r\n.parch-chip-pair {\r\n  background: var(--color-accent, #3b82f6);\r\n  color: #fff;\r\n}\r\n\r\n.parch-detail {\r\n  flex: 1;\r\n  min-width: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  border: 1px solid var(--color-border, #e0e0e0);\r\n  border-radius: 4px;\r\n  background: var(--color-bg, #fff);\r\n  overflow: hidden;\r\n}\r\n.parch-detail-head {\r\n  padding: 8px 10px;\r\n  border-bottom: 1px solid var(--color-border, #eee);\r\n  flex-shrink: 0;\r\n}\r\n.parch-detail-title {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: var(--color-text, #1f2937);\r\n}\r\n.parch-summary,\r\n.parch-note {\r\n  margin-top: 4px;\r\n  font-size: 11px;\r\n  color: var(--color-text-secondary, #6b7280);\r\n  line-height: 1.5;\r\n}\r\n\r\n.parch-preview {\r\n  flex: 1;\r\n  min-height: 0;\r\n  overflow: auto;\r\n  margin: 0;\r\n  padding: 8px 10px;\r\n  font-family: 'Consolas', 'Monaco', monospace;\r\n  font-size: 11px;\r\n  line-height: 1.45;\r\n  white-space: pre;\r\n  color: var(--color-text, #333);\r\n  background: var(--color-bg-secondary, #fafafa);\r\n}\r\n\r\n.parch-empty {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 6px;\r\n  height: 100%;\r\n  min-height: 120px;\r\n  padding: 16px;\r\n  font-size: 12px;\r\n  font-style: italic;\r\n  color: var(--color-text-muted, #9ca3af);\r\n  text-align: center;\r\n}\r\n\r\n.parch-actions {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  flex-wrap: wrap;\r\n  flex-shrink: 0;\r\n}\r\n/* 되돌릴 수 없는 것은 오른쪽 끝에 따로 세운다 — 옆 버튼과 손이 섞이지 않게 */\r\n.parch-delete { margin-left: auto; }\r\n\r\n[data-theme=\"dark\"] .parch-list,\r\n[data-theme=\"dark\"] .parch-detail { background: var(--color-bg-secondary); border-color: var(--color-border); }\r\n[data-theme=\"dark\"] .parch-preview { background: var(--color-bg); color: var(--color-text); }\r\n[data-theme=\"dark\"] .parch-item { border-bottom-color: var(--color-border); }\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .parch-item { transition: none; }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
